<nav class="navbar navbar-expand-lg bg-light d-none d-lg-block">
    <div class="container">
        <a class="navbar-brand" href="#">IMAP</a>
        <div class="navbar-collapse show d-flex flex-row align-items-center justify-content-between" id="navbarText"
            style="display: flex !important;">
            <ul class="navbar-nav me-auto mb-0 flex-row menu-links">
                <li class="nav-item">
                    <a class="nav-link active" aria-current="page" href="#">Logar</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">Tutoriais</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">Registrar</a>
                </li>
            </ul>
            <span class="navbar-text d-flex align-items-center menu-actions">
                <div class="compartilhar-container">
                    <button class="btn btn-default btn-compartilhar btn-icon-action" (click)="compartilharPagina()"
                        title="Compartilhar">
                        <i class="fa-solid fa-share-nodes"></i>
                        <span class="btn-text">Compartilhar página</span>
                    </button>
                    <div *ngIf="mostrarMensagem" class="mensagem-compartilhar">
                        <div class="icone-compartilhar" data-size="48">
                            <i class="fa-regular fa-clone"></i>
                        </div>
                        <div class="texto-compartilhar">
                            Compartilhar Link: www.impa.com.br
                        </div>
                    </div>
                </div>
                <button class="btn btn-outline-primary btn-icon-action btn-icon-action-avaliacao" data-bs-toggle="modal"
                    data-bs-target="#avaliacaoAtendimento" title="Avaliar">
                    <i class="fa-regular fa-star"></i>
                    <span class="btn-text">Avaliar nosso produto</span>
                </button>
            </span>
        </div>
    </div>
</nav>

<!--Modais-->
<div class="modal fade" id="avaliacaoAtendimento" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title fs-5 text-informacao" id="exampleModalLabel">
                </h6>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <div class="p-1">
                    <h2 class="mb-3 text-label fw-700">Queremos sua opinião</h2>
                    <h6 class="text-label">Em uma escala de 0 a 10, qual a probabilidade de você nos recomendar?
                    </h6>
                    <hr>
                    <div class="d-flex justify-content-between mb-2 fw-bold">
                        <span>Pouco provável</span>
                        <span>Muito provável</span>
                    </div>

                    <div class="d-flex flex-wrap justify-content-between rating-scale mb-4">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="nota" id="nota0" value="0">
                            <label class="form-check-label" for="nota0">0</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="nota" id="nota1" value="1">
                            <label class="form-check-label" for="nota1">1</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="nota" id="nota2" value="2">
                            <label class="form-check-label" for="nota2">2</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="nota" id="nota3" value="3">
                            <label class="form-check-label" for="nota3">3</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="nota" id="nota4" value="4">
                            <label class="form-check-label" for="nota4">4</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="nota" id="nota5" value="5">
                            <label class="form-check-label" for="nota5">5</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="nota" id="nota6" value="6">
                            <label class="form-check-label" for="nota6">6</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="nota" id="nota7" value="7">
                            <label class="form-check-label" for="nota7">7</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="nota" id="nota8" value="8">
                            <label class="form-check-label" for="nota8">8</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="nota" id="nota9" value="9">
                            <label class="form-check-label" for="nota9">9</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="nota" id="nota10" value="10">
                            <label class="form-check-label" for="nota10">10</label>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="comentario" class="text-label">Conte-nos mais sobre sua experiência
                            (opcional)</label>
                        <textarea class="form-control" id="comentario" rows="10"
                            placeholder="Deixe seu comentário aqui..." style="border: 1px solid #E2E8F0 !important;
height: 110px;"></textarea>
                    </div>

                    <button class="btn btn-primary w-100">Enviar Feedback</button>
                </div>
            </div>
        </div>
    </div>
</div>